import * as React from "react"
import { Flex, ButtonGroup, IconButton, Text } from "@chakra-ui/react"
import useOnClickWithTouchHandler from "../../../../hooks/useOnClickWithTouchHandler"
import { FiMinus, FiPlus } from "react-icons/fi"
import { QuantitySelectorProps } from "./types"
import { useRecoilValue } from "recoil"
import { brandingSelector } from "../../../../recoil/atoms/room"
import { viewDependingLayoutAtom } from "../../../../recoil/atoms/view"

const _QuantitySelector: React.FC<QuantitySelectorProps> = ({
  onChange,
  value,
  isSmallMainScreen
}): JSX.Element => {
  const roomStyles = useRecoilValue(brandingSelector)
  const { isMobile, isTablet } = useRecoilValue(viewDependingLayoutAtom)
  const onIncClick = React.useCallback(
    e => {
      e.preventDefault()
      e.stopPropagation()
      onChange(++value)
    },
    [value, onChange]
  )

  const onDecClick = React.useCallback(
    e => {
      e.preventDefault()
      e.stopPropagation()
      if (value > 1) onChange(--value)
    },
    [value, onChange]
  )

  const incHandlers = useOnClickWithTouchHandler(onIncClick)
  const decHandlers = useOnClickWithTouchHandler(onDecClick)

  return (
    <ButtonGroup
      size={isSmallMainScreen ? "xs" : "sm"}
      isAttached
      variant={"outline"}
    >
      <IconButton
        aria-label="Add to friends"
        icon={<FiMinus />}
        disabled={value <= 1}
        fontSize={"1.3rem"}
        padding={"0.2rem 0.2rem"}
        {...decHandlers}
        bg={roomStyles?.badgeSecondaryButtonBackgroundColor}
        _hover={{
          bg:
            (isTablet || (!isMobile && !(value <= 1))) &&
            roomStyles?.badgeSecondaryButtonMouseoverColor,
          color:
            (isTablet || (!isMobile && !(value <= 1))) &&
            roomStyles?.badgeSecondaryButtonTextMouseoverColor
        }}
        borderColor={roomStyles?.badgeSecondaryButtonBorderColor}
        color={roomStyles?.badgeSecondaryButtonTextColor}
        _active={{}}
        _disabled={{
          opacity: 0.75,
          bg: roomStyles?.badgeSecondaryButtonBackgroundColor,
          cursor: "not-allowed"
        }}
        _focus={{}}
      />
      <Flex minWidth={"10"} justifyContent="center" alignItems={"center"}>
        <Text
          opacity={0.86}
          fontSize={isSmallMainScreen ? "xs" : "sm"}
          fontWeight="medium"
          color={roomStyles?.badgeTextColor && roomStyles?.badgeTextColor}
        >
          {value}
        </Text>
      </Flex>
      <IconButton
        aria-label="Add to friends"
        icon={<FiPlus />}
        // disabled={!selectedVariant}
        fontSize={"1.3rem"}
        bg={roomStyles?.badgeSecondaryButtonBackgroundColor}
        _hover={{
          bg:
            (isTablet || !isMobile) &&
            roomStyles?.badgeSecondaryButtonMouseoverColor,
          color:
            (isTablet || !isMobile) &&
            roomStyles?.badgeSecondaryButtonTextMouseoverColor
        }}
        borderColor={roomStyles?.badgeSecondaryButtonBorderColor}
        color={roomStyles?.badgeSecondaryButtonTextColor}
        {...incHandlers}
        _active={{}}
        _disabled={{
          opacity: 0.75,
          bg: roomStyles?.badgeSecondaryButtonBackgroundColor,
          cursor: "not-allowed"
        }}
        _focus={{}}
        padding={"0.2rem 0.2rem"}
      />
    </ButtonGroup>
  )
}

export const QuantitySelector = React.memo(_QuantitySelector)
